import { render, staticRenderFns } from "./dialog-appeals.vue?vue&type=template&id=8b4340ec"
import script from "./dialog-appeals.vue?vue&type=script&lang=js"
export * from "./dialog-appeals.vue?vue&type=script&lang=js"
import style0 from "./dialog-appeals.vue?vue&type=style&index=0&id=8b4340ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports